import { theme } from 'component-library/utils';

import { GraphTileType } from '@/api/rest/resources/types/widget';

export const SHARED_CHART_COLORS = {
  referenceLines: { stroke: '#0000004D', label: '#00000099' },
  confidenceIntervals: { fill: '#D5D5D5' },
  axis: { stroke: theme.colors?.['neutral-black-12'] as string },
} as const;

export const GRAPHS_WITH_CUSTOM_BENCHMARKS = new Set([
  GraphTileType.historic_below_ground_carbon,
  GraphTileType.historic_above_ground_carbon,
  GraphTileType.historic_water_soil_moisture,
  GraphTileType.protected_on_farm_habitat,
  GraphTileType.ndvi,
  GraphTileType.historic_deforestation,
]);
